
import Body from './body'
import BottomContext from './bottom'
const TempleteFour = () => {
    return <>
        <Body></Body>
        <BottomContext></BottomContext>
    </>
}

export default TempleteFour